import React, { useState, useRef, useEffect } from 'react';
import customStyles from "../../../../../../assets/styles/customStyles";
import { TextField, RadioGroup, FormControlLabel, Radio, FormControl } from "@mui/material";
import { Row, Col, Image } from "antd";
import clsx from 'clsx';
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { PaymentProcess } from "./PaymentProcess";
import { checkProductSearch, storageSetItem, idNamingConversion } from "../../../../../../helpers/utilities";
import { KeyBoardView } from './KeyBoardView';
import { TileView } from './TileView';
import { NavLink } from "react-router-dom";
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";
import FilterView from "./FilterView";
import { SelectedIcon, UnSelectedIcon } from "../../../../../Shared/components/Icons/selectedIcon";

export const LeftSide = (props) => {
    const { paymentProcess, roleManagement, checkComponentPermission, handleActiveInputs, handleNameDisplay, showNameDesc,
        handleSearch, details, changeHandlerTopBar, productGroupDetails, search, viewType, form,
        loadMore, customObject, handleViewType } = props;
    const [height, setHeight] = useState();
    const [iconAnimation, setIconAnimation] = useState(false);
    const leftTopRef = useRef(null);

    useEffect(() => {
        if (leftTopRef?.current) {
            let h = `calc(100% - ${leftTopRef?.current?.clientHeight + 30}px)`;
            setHeight(h);
        }
    }, [leftTopRef, paymentProcess, loadMore, details]);

    const changeSearchType = (value) => {
        changeHandlerTopBar('productSearch', value);
        storageSetItem('productSearch', value);
    }



    const classes = customStyles();
    return (
        <div className={clsx(classes.leftStoreSales)}>
            {
                !paymentProcess ? <>
                    {
                        viewType === 'tile' && <Row className={{ [classes.customDisabled]: form?.isReturnWithReceipt }} style={{ alignItems: "center" }} ref={leftTopRef} gutter={10}>
                            <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20}>
                                {
                                    roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Search') &&
                                    <div className={clsx(classes.dropDownWithSearch, classes.customerLabelNone)}>
                                        <AutoCompleteComponent
                                            customLabel={"Type"}
                                            heads={[{ 'key': 'label', 'name': 'Search Configuration' }]}
                                            details={[{ id: 'name', label: "Name" }, { id: 'code', label: "Code" }, { id: 'both', label: "Both" }, { id: 'standard', label: "Standard" }, { id: 'mrp', label: "MRP" }]}
                                            parentValue={customObject([{ id: 'name', label: "Name" }, { id: 'code', label: "Code" }, { id: 'both', label: "Both" }, { id: 'standard', label: "Standard" }, { id: 'mrp', label: "MRP" }], checkProductSearch())}
                                            position={"bottom"}
                                            variant={'outlined'}
                                            onChange={(data) => changeSearchType(data.id)}
                                        />
                                        <div className={clsx(classes.searchAnimation, classes.customerLabelNone, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder={
                                                    checkProductSearch() === 'standard' ? 'Search Name, Description, ID, Bar Code, and Code' :
                                                        checkProductSearch() === 'both' ? 'Search Name, and Code' :
                                                            checkProductSearch() === 'name' ? 'Search Name' :
                                                                checkProductSearch() === 'code' ? 'Search Code' : ''
                                                }
                                                type='search'
                                                value={search}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={(e) => { setIconAnimation(true); handleActiveInputs(e.target.name) }}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                            {
                                                search && <NavLink to="#" onClick={() => handleSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    </div>
                                }
                            </Col>
                            <Col span={4}>
                                {
                                    viewType === 'tile' && <FilterView {...props} classes={classes} />
                                }
                            </Col>
                        </Row>
                    }
                    <div style={{ height: `calc(100% - 54px)` }}>
                        <Row align="middle" className={clsx(classes.customerLabelNone, { [classes.customDisabled]: form?.isReturnWithReceipt })} style={{ padding: "10px 0 10px 0" }}>
                            <Col xxl={10} xl={10} lg={10} md={10} sm={24} xs={24} className={classes.filterViewParent}>
                                <FormControl
                                    className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                    variant={'standard'}
                                    fullWidth>
                                    <RadioGroup
                                        row
                                        value={showNameDesc}
                                        onChange={(e) => handleNameDisplay(e.target.value)}>
                                        <FormControlLabel value="name" control={<Radio
                                            checkedIcon={<UnSelectedIcon />}
                                            icon={<SelectedIcon />}
                                        />} label="Name" />
                                        <FormControlLabel value="description" control={<Radio
                                            checkedIcon={<UnSelectedIcon />}
                                            icon={<SelectedIcon />}
                                        />} label="Description" />
                                    </RadioGroup>
                                </FormControl>
                            </Col>
                            <Col xxl={14} xl={14} lg={14} md={14} sm={24} xs={24} className={clsx(classes.textAlignRight)}>
                                <FormControl
                                    tabIndex={-1}
                                    className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                                    variant={'standard'}
                                    fullWidth>
                                    <RadioGroup row
                                        defaultValue="ACTIVE"
                                        aria-labelledby="demo-customized-radios"
                                        name="status"
                                        style={{ justifyContent: "end" }}
                                        value={viewType || false}
                                        onChange={(e) => handleViewType(e.target.value)}
                                        id={idNamingConversion('viewType', 'storeSales', 'Radio')}>
                                        <FormControlLabel value="tile" control={<Radio
                                            checkedIcon={<UnSelectedIcon />}
                                            icon={<SelectedIcon />}
                                        />} label="Tile View" />
                                        <FormControlLabel value="keyboard" control={<Radio
                                            checkedIcon={<UnSelectedIcon />}
                                            icon={<SelectedIcon />}
                                        />} label="Keyboard View" />
                                        <FormControlLabel value="barcode" control={<Radio
                                            checkedIcon={<UnSelectedIcon />}
                                            icon={<SelectedIcon />}
                                        />} label="Barcode" />
                                    </RadioGroup>
                                </FormControl>
                            </Col>
                        </Row>
                        {
                            viewType === 'tile' ? <TileView
                                height={height}
                                changeHandlerTopBar={(name, value) => changeHandlerTopBar(name, value)}
                                productGroupDetails={productGroupDetails}
                                handleViewType={(t) => handleViewType(t)}
                                {...props} /> : <KeyBoardView type={viewType} {...props} handleViewType={(t) => handleViewType(t)} />
                        }
                    </div>
                </> : <PaymentProcess {...props} />
            }
        </div>
    )
}